import { useAppStore } from "@/stores/appStore"
const BASE_URI = "school/student-report"

export default {
  listReport() {
    const appStore = useAppStore()
    return appStore.fetchListCached(`${BASE_URI}/list`)
  },
  listSatisfaction() {
    const appStore = useAppStore()
    return appStore.fetchListCached(`${BASE_URI}/satisfaction-scale`)
  },
  listReportProgramById(params = "") {
    const appStore = useAppStore()
    return appStore.fetchListCached(`${BASE_URI}/detail/${params}`)
  },
}
